import { ITwilioState } from 'entities/Calls/Twilio.models';

export const twilioReducers = {
  setToken: (state: ITwilioState, payload: string | null) => ({ ...state, token: payload }),
  setLoading: (state: ITwilioState, payload: boolean) => ({ ...state, loading: payload }),
  setOnCall: (state: ITwilioState, payload: boolean) => ({ ...state, onCall: payload }),
  setDuration: (state: ITwilioState, payload: number | null) => ({ ...state, duration: payload }),
};
